import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';

import moment from 'moment';
import 'moment/locale/pt-br';

import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as EmpresaAPI from '../../../api/empresa';
import * as TabelaAPI from '../../../api/tabela';

import CrudsAPI from '../../../api/CRUDs';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { resolveEmpresaTabela } from '../../../utils/funcoes';

const CreateOrEdit = () => {
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();
    const [dados, setDados] = useState({
        empresaId: empresaId,
        data: moment().format('YYYY-MM-DD 00:00:00'),
        ativo: true,
        vigente: true,
    });
    const token = localStorage.getItem('token') || '';
    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const pathname = '/RH';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //configuração por tipo de RH
    const RH_TIPOS = {
        funcional: {
            api: CrudsAPI.rh,
        },

        ferias: {
            api: CrudsAPI.rhFerias,
        },

        afastamento: {
            api: CrudsAPI.rhAfastamentos,
        },

        vacinacao: {
            api: CrudsAPI.vacinacao,
        },

        exame: {
            api: CrudsAPI.rhExame,
        },

        declaracao: {
            api: CrudsAPI.declaracoes,
        },
        declaracaoTipos: {
            api: CrudsAPI.rhDeclaracaoTipos,
        },
        dependente: {
            api: CrudsAPI.rhDependentes,
        },
    };

    //obtem configuração por tipo
    const config = RH_TIPOS[tipo] ?? {
        api: CrudsAPI.rh,
    };

    const api = config.api ?? CrudsAPI.rh;

    //enums e tabelas
    const [OptionsEmpresa, setEmpresa] = useState([]);
    const [enumParentesco, setEnumParentesco] = useState([]);

    //carregar API's Externas
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(dados.empresaId);
        setEmpresa(result);
    };
    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);
        if (table === 'rhDependentes') {
            field === 'parentesco' && setEnumParentesco(result ? result : []);
        }
    };

    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        consultaEmpresa();
        consultaEnum('rhDependentes', 'parentesco', null);

        if (!uuid || uuid === 'null') return;

        if (!api?.consulta) {
            console.error('API consulta não configurada para o tipo:', tipo, config);
            setFlashMessage(`API não configurada para ${tipo}`, 'error');
            return;
        }

        api.consulta(uuid)
            .then((response) => {
                setDados(response.data);
            })
            .catch((error) => {
                console.error(error);
                setFlashMessage(
                    error?.response?.data?.message || 'Erro ao consultar registro.',
                    error?.response?.data?.type || 'error'
                );
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid, api]);

    async function managerDados(dados) {
        let urlNavigate = pathname;

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await api.editar(dados);
            } else {
                response = await api.cadastrar(dados);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                handleSubmit={managerDados}
                dados={dados}
                setDados={setDados}
                btnText={btnText}
                OptionsEmpresa={OptionsEmpresa}
                enumParentesco={enumParentesco}
                caminhoVoltar={pathname}
                pessoaId={pessoaId}
                empresaId={empresaId}
                empresaIds={empresaIds}
                empresaTabelaId={empresaTabelaId}
            />
        </section>
    );
};
export default CreateOrEdit;
